import React, { useState } from 'react';
import Modal from 'react-modal';
import ShareButton from '../share-button/share-button';

import './modal-share-post-style.css';
import Svg from '../icons/svg';

Modal.setAppElement('#app-root');

function ModalSharePost(props) {
  const [shareModalIsOpen, setShareModalIsOpen] = useState(false);

  function openShareModal() {
    setShareModalIsOpen(true);
  }

  function closeShareModal() {
    setShareModalIsOpen(false);
  }

  return (
    <React.Fragment>
      <button className="d-flex align-items-center justify-content-center c-p p-8p" onClick={openShareModal}>
        <div className="align-items-center justify-content-center">
          <Svg name="share" label="Share Post" fill="#262626" height="24" width="24" />
        </div>
      </button>

      <Modal isOpen={shareModalIsOpen} onRequestClose={closeShareModal} contentLabel="Share Modal">
        <div className="card border-none share-modal">
          <div className="card-header">
            <div className="rla" />
            <h1 className="title d-flex text-center align-items-center f-grow-1 justify-content-center">اشتراک گذاری</h1>
            <div className="rla">
              <button
                type="button"
                className="d-flex align-items-center justify-content-center c-p p-8p"
                onClick={closeShareModal}
              >
                <Svg name="multiply" label="Close" fill="#262626" height="24" width="24" />
              </button>
            </div>
          </div>

          <div className="card-body p-0 py-8p">
            <ShareButton social={'twitter'} path={props.path} />
            <ShareButton social={'mail'} path={props.path} />

            <div
              onClick={closeShareModal}
              className="py-8p px-16p f-row f-00auto justify-content-start align-items-center align-content-stretch bg-hover-dark-10 c-p"
            >
              <div className="ml-12p f-00auto align-items-stretch align-content-stretch">
                <div className="wh-32p align-items-center justify-content-center" />
              </div>
              <div className="min-wh-0 f-11auto justify-content-center align-content-stretch align-items-stretch">
                <div className="font-size-5 f-row align-items-center justify-content-start color-main">لغو</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default ModalSharePost;
